module.exports = __webpack_public_path__ + "static/media/arrow.6766cfc2.svg";